import { formatCurrency } from '../../helpers/formatCurrency';

import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CartTray: FunctionComponent<Props> = ({
    className = '',
    itemCount,
    onOpen,
    subtotal,
    testId = TEST_ID
}) => {
    const { OPEN_CART } = useTranslation();

    if (itemCount === 0) {
        return null;
    }

    return (
        <HorizontalContainer
            className={`${styles.cartTray} ${className}`}
            onClick={onOpen}
            testId={testId}>
            <Wrapper>{`${itemCount}`}</Wrapper>

            <Wrapper className={styles.cartTraySep}>·</Wrapper>

            <Wrapper>{formatCurrency(subtotal)}</Wrapper>

            <Wrapper className={styles.cartTraySep}>·</Wrapper>

            <Wrapper>{OPEN_CART}</Wrapper>
        </HorizontalContainer>
    );
};

export default CartTray;
